import { ENV } from "../utils";

export class Topic {
  baseApi = ENV.BASE_API;

  async getTopics(accessToken, active = true) {
    const url = `${this.baseApi}/topics?active=${active}`;
    const response = await fetch(url, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async createTopic(accessToken, data) {
    const response = await fetch(`${this.baseApi}/add-topic`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async updateTopic(accessToken, id, data) {
    const response = await fetch(`${this.baseApi}/update-topic/${id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async deleteTopic(accessToken, id) {
    const response = await fetch(`${this.baseApi}/delete-topic/${id}`, {
      method: "DELETE",
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }
}
